<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const teams = [
  'BC Kalev/Cramo',
  'Keila Coolbet',
  'BK Liepaja',
  'BK Ogre',
  'BK Ventspils',
  'Keila Korvpallikool',
  'Latvijas Universitate',
  'Pärnu Sadam',
  'Rigas Zelli',
  'TAI TECH'
]

const searchQuery = ref('')
const filteredTeams = computed(() => {
  if (!searchQuery.value) return teams
  return teams.filter(team => 
    team.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})
</script>

<template>
  <div class="p-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-6">
      <div>
        <h1 class="text-2xl font-bold">Select League</h1>
        <p class="text-gray-500">Dashboard / Teams</p>
      </div>
    </div>

    <!-- Search and Create -->
    <div class="flex gap-4 mb-6">
      <div class="relative flex-1">
        <input 
          v-model="searchQuery"
          type="text" 
          placeholder="Search teams"
          class="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:border-pink-500"
        >
        <i class="fas fa-search absolute left-3 top-3 text-gray-400"></i>
      </div>
      <div class="flex gap-2">
        <input 
          type="text" 
          placeholder="Create new team"
          class="px-4 py-2 border rounded-lg focus:outline-none focus:border-pink-500"
        >
        <button class="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
          Save
        </button>
      </div>
    </div>

    <!-- Teams List -->
    <div class="bg-white rounded-lg shadow divide-y">
      <router-link
        v-for="team in filteredTeams"
        :key="team"
        :to="`/games/rosters/team/${encodeURIComponent(team)}`"
        class="flex items-center p-4 hover:bg-gray-50"
      >
        <span>{{ team }}</span>
        <i class="fas fa-chevron-right ml-auto text-gray-400"></i>
      </router-link>
    </div>
  </div>
</template> 